import type { ArticleItem } from "@/mocks/chigua";

export default function NewsCard({ item }: { item: ArticleItem }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:-translate-y-0.5 hover:border-primary-200">
      <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
        <img
          src={item.image}
          alt={item.alt}
          loading="lazy"
          className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-[1.05]"
        />
        <span className="absolute left-2.5 top-2.5 inline-flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 font-label text-[11px] font-bold text-background-50 backdrop-blur">
          <i className="ri-fire-line text-accent-300"></i>
          {item.tag}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition group-hover:text-primary-600 md:text-[17px]">
          <span className="line-clamp-2">{item.title}</span>
        </h3>
        <p className="mt-2 text-[13px] leading-relaxed text-foreground-600 line-clamp-2">
          {item.excerpt}
        </p>
        <div className="mt-auto flex items-center gap-3 pt-3 text-xs text-foreground-400">
          <span className="inline-flex items-center gap-1">
            <i className="ri-time-line"></i>
            {item.time}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {item.views}
          </span>
          <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-800">
            {item.duration}
          </span>
        </div>
      </div>
    </article>
  );
}